import React, { useRef, useState } from 'react';
import _debounce from 'lodash/debounce';
import styles from './SearchMultiSelect.module.scss';

const search = _debounce((searchString, handleSearch) => handleSearch(searchString), 250);

interface Props {
  handleSearch: Function;
  initialSelection: object[];
  searchResults: object[];
  renderSearchResults: Function;
  renderSelectedItem: Function;
  onChange: Function;
}

const SearchMultiSelect = (props: Props) => {
  const { handleSearch, initialSelection, onChange, renderSelectedItem, renderSearchResults } = props;
  const [searchSelection, setSearchSelection] = useState(initialSelection || []);
  const [searchString, setSearchString] = useState('');
  const searchContainer = useRef<HTMLDivElement>(null);
  const searchInput = useRef<HTMLInputElement>(null);

  const handleSearchChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newSearchString = event.target.value || '';
    setSearchString(newSearchString);
    search(newSearchString, handleSearch);
  };

  const handleResultSelect = (record: object) => {
    const newSearchSelection = [...searchSelection, record];
    setSearchString('');
    setSearchSelection(newSearchSelection);
    if (searchInput.current) {
      searchInput.current?.focus();
    }
    const currentSearchContainer = searchContainer.current;
    if (currentSearchContainer) {
      setTimeout(() => {
        currentSearchContainer.scrollTo(0, currentSearchContainer.scrollHeight);
      });
    }
    onChange(newSearchSelection);
  };

  return (
    <div className={styles.container}>
      <div className={styles.selectionsContainer} ref={searchContainer}>
        {searchSelection.map((s) => renderSelectedItem(s, searchSelection, setSearchSelection))}
        <input
          type="text"
          ref={searchInput}
          value={searchString}
          onChange={handleSearchChange}
          className={styles.searchInput}
          data-testid="moderator-search-input"
        />
      </div>
      {searchString && searchString.length && renderSearchResults(handleResultSelect, searchString, searchContainer)}
    </div>
  );
};

export default SearchMultiSelect;
